import { gql } from '@apollo/client';
import { strategyGuideFullAttributes } from '@aims/shared/strategy-guides/constants';

export const getAttachmentUploadUrlForAdminMutation = gql`
  mutation GetAttachmentUploadUrlForAdmin(
    $attachment: GetAttachmentUploadUrlRequest!
  ) {
    getAttachmentUploadUrlForAdmin(attachment: $attachment) {
      url
      fields
    }
  }
`;

export const saveAttachmentForAdminMutation = gql`
  mutation SaveAttachmentForAdmin($attachment: SaveAttachmentInput!) {
    saveAttachmentForAdmin(attachment: $attachment) {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      uploaded
      processed
      attachedTo
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;

export const createStrategyGuideMutation = gql`
  mutation CreateStrategyGuide($strategyGuide: StrategyGuideCreateInput!) {
    createStrategyGuide(strategyGuide: $strategyGuide) {
      strategyGuide ${strategyGuideFullAttributes}
      historyIds
    }
  }
`;

export const updateStrategyGuideMutation = gql`
  mutation UpdateStrategyGuide($strategyGuide: StrategyGuideUpdateInput!) {
    updateStrategyGuide(strategyGuide: $strategyGuide) {
      strategyGuide ${strategyGuideFullAttributes}
      historyIds
    }
  }
`;

export const deleteStrategyGuideMutation = gql`
  mutation DeleteStrategyGuide($_id: ID!) {
    deleteStrategyGuide(_id: $_id) {
      deletedId
      historyIds
    }
  }
`;

export const reviewStrategyGuideMutation = gql`
  mutation ReviewStrategyGuide($review: StrategyGuideReviewInput!) {
    reviewStrategyGuide(review: $review) {
      strategyGuide ${strategyGuideFullAttributes}
      historyIds
    }
  }
`;
